// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f71020ed","453":"1473569a"}[chunkId] + ".chunk.js";
};